import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../styles/CompanyDetailPage.css';

const CompanyDetailPage = () => {
  const { slug } = useParams();
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  // Company data - in a real app, this would come from an API
  const companyData = {
    kusgrup: {
      name: 'KUS GRUP',
      logo: './images/kusgrup.png',
      logoYatay: './images/kusgrupyatay.png',
      description: 'Ana şirketimiz olarak çatı sistemleri ve yapı malzemeleri alanında lider konumdadır.',
      fullDescription: `
        KUS GRUP, 1995 yılından bu yana yapı sektöründe faaliyet gösteren, çatı sistemleri ve yapı malzemeleri 
        konusunda uzmanlaşmış bir şirkettir. Müşterilerimize en kaliteli ürünleri sunmak ve projelerinizi 
        zamanında tamamlamak için çalışıyoruz.
        
        Sunduğumuz hizmetler arasında çatı kaplama, yalıtım sistemleri, cephe sistemleri ve çelik 
        konstrüksiyon bulunmaktadır. Deneyimli ekibimiz ve geniş ürün yelpazemiz ile her türlü projeye 
        uygun çözümler üretiyoruz.
      `,
      services: [
        'Çatı Sistemleri',
        'Cephe Kaplamaları',
        'Yalıtım Çözümleri',
        'Çelik Konstrüksiyon',
        'Proje Danışmanlığı'
      ],
      contactInfo: {
        address: 'İstanbul Yolu 30. km, Ankara',
        phone: '+90 312 123 4567',
        email: 'info@kusgrup.com.tr'
      },
      gallery: [
        './images/kusgrup.png',
        './images/kusgrupyatay.png'
      ]
    },
    marmara: {
      name: 'Marmara',
      logo: './images/marmara.png',
      logoYatay: './images/marmarayatay.png',
      description: 'Marmara markamız ile yapı malzemeleri sektöründe kaliteli ürünler sunuyoruz.',
      fullDescription: `
        Marmara, KUS GRUP bünyesinde 2005 yılında kurulmuş, yapı malzemeleri alanında uzmanlaşmış bir markadır. 
        Kaliteli hammadde ve modern üretim teknikleri ile üretilen ürünlerimiz, dayanıklılığı ve estetik 
        görünümü ile ön plana çıkmaktadır.
        
        Geniş ürün yelpazemiz ile müşterilerimizin tüm ihtiyaçlarına cevap veriyoruz. Ürünlerimiz, 
        Türkiye'nin dört bir yanındaki projelerde güvenle kullanılmaktadır.
      `,
      services: [
        'Yapı Malzemeleri Üretimi',
        'Toptan Satış',
        'Özel Üretim',
        'Lojistik Hizmetler',
        'Teknik Destek'
      ],
      contactInfo: {
        address: 'Gebze Organize Sanayi Bölgesi, Kocaeli',
        phone: '+90 262 987 6543',
        email: 'info@marmara.com'
      },
      gallery: [
        './images/marmara.png',
        './images/marmarayatay.png'
      ]
    },
    gebzepalet: {
      name: 'Gebze Palet',
      logo: './images/gebzepalet.png',
      logoYatay: './images/gebzepaletyatay.png',
      description: 'Gebze Palet markamız ile lojistik ve depolama çözümleri sağlıyoruz.',
      fullDescription: `
        Gebze Palet, KUS GRUP bünyesinde 2010 yılında kurulmuş, lojistik ve depolama çözümleri sunan bir markadır. 
        Ahşap, plastik ve metal paletler üreterek, farklı sektörlerdeki müşterilerimizin ihtiyaçlarına 
        uygun çözümler sunuyoruz.
        
        Ürettiğimiz paletler, dayanıklılık ve taşıma kapasitesi açısından sektörün en iyileri arasında 
        yer almaktadır. Ayrıca, özel tasarım palet üretimi ile müşterilerimizin spesifik ihtiyaçlarına 
        da cevap veriyoruz.
      `,
      services: [
        'Ahşap Palet Üretimi',
        'Plastik Palet Üretimi',
        'Metal Palet Üretimi',
        'Özel Tasarım Paletler',
        'Depolama Çözümleri'
      ],
      contactInfo: {
        address: 'Gebze 2. Organize Sanayi Bölgesi, Kocaeli',
        phone: '+90 262 456 7890',
        email: 'info@gebzepalet.com'
      },
      gallery: [
        './images/gebzepalet.png',
        './images/gebzepaletyatay.png'
      ]
    }
  };

  useEffect(() => {
    // In a real app, this would be an API call
    const fetchCompanyData = () => {
      setLoading(true);
      setTimeout(() => {
        if (companyData[slug]) {
          setCompany(companyData[slug]);
        } else {
          // Handle case where company doesn't exist
          console.error('Company not found');
        }
        setLoading(false);
      }, 500); // Simulate API delay
    };

    fetchCompanyData();
  }, [slug]);

  // Animation variants
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (!company) {
    return (
      <div className="not-found-container">
        <h2>Şirket bulunamadı</h2>
        <p>Aradığınız şirket bilgilerine ulaşılamadı.</p>
        <Link to="/" className="back-btn">Ana Sayfaya Dön</Link>
      </div>
    );
  }

  return (
    <div className="company-detail-page">
      <div className="particles-container" id="particles-js"></div>
      
      <div className="container">
        <motion.div 
          className="company-header"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="company-logo-container">
            <img src={company.logoYatay || company.logo} alt={`${company.name} Logo`} className="company-detail-logo" />
          </div>
        </motion.div>

        <div className="company-content">
          <motion.div 
            className="company-info-section"
            variants={fadeIn}
            initial="hidden"
            animate="visible"
          >
            <h1>{company.name}</h1>
            <div className="company-description">
              {company.fullDescription.split('\n').map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </motion.div>

          <motion.div 
            className="company-services-section"
            variants={fadeIn}
            initial="hidden"
            animate="visible"
            transition={{ delay: 0.2 }}
          >
            <h2>Hizmetlerimiz</h2>
            <ul className="services-list">
              {company.services.map((service, index) => (
                <motion.li 
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.3 + index * 0.1 }}
                >
                  {service}
                </motion.li>
              ))}
            </ul>
          </motion.div>

          <motion.div 
            className="company-contact-section"
            variants={fadeIn}
            initial="hidden"
            animate="visible"
            transition={{ delay: 0.4 }}
          >
            <h2>İletişim Bilgileri</h2>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <p>{company.contactInfo.address}</p>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <p>{company.contactInfo.phone}</p>
              </div>
              <div className="contact-item">
                <span className="contact-icon">✉️</span>
                <p>{company.contactInfo.email}</p>
              </div>
            </div>
          </motion.div>

          {company.gallery && company.gallery.length > 0 && (
            <motion.div 
              className="company-gallery-section"
              variants={fadeIn}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.6 }}
            >
              <h2>Galeri</h2>
              <div className="gallery-grid">
                {company.gallery.map((image, index) => (
                  <motion.div 
                    key={index} 
                    className="gallery-item"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.7 + index * 0.1 }}
                  >
                    <img src={image} alt={`${company.name} ${index + 1}`} />
                  </motion.div>
                ))}
              </div>
            </motion.div>
          )}

          <motion.div 
            className="back-link-container"
            variants={fadeIn}
            initial="hidden"
            animate="visible"
            transition={{ delay: 0.8 }}
          >
            <Link to="/" className="back-btn">
              <span>←</span> Ana Sayfaya Dön
            </Link>
          </motion.div>
        </div>
      </div>
      
      <div className="glowing-dot" style={{ top: '20%', left: '10%' }}></div>
      <div className="glowing-dot" style={{ top: '60%', left: '80%' }}></div>
    </div>
  );
};

export default CompanyDetailPage; 